/* MT Sports — preservação da atribuição.
   cid e UTMs permanecem disponíveis na URL para a CartPanda e os scripts
   assíncronos de atribuição. Um prazo fixo de 800 ms não confirma que esses
   scripts já terminaram de ler os parâmetros.
   Este arquivo não dispara eventos do pixel. */

/* MT Sports — proteção do fluxo de compra para botões especiais (qtd/compre junto).
   Corrige o caminho legado que adicionava o item, mas podia disparar o carrinho
   com uma variante inexistente. O fluxo normal dos demais produtos não é alterado. */
(function () {
  "use strict";

  if (window.__mtSpecialBuyFlowInitialized) return;
  window.__mtSpecialBuyFlowInitialized = true;

  function specialBuyButton(target) {
    return target && target.closest
      ? target.closest(
          ".product-form .botaocmprar, .product-form .botaoaddcarrinho-qtd",
        )
      : null;
  }

  document.addEventListener(
    "click",
    function (event) {
      var button = specialBuyButton(event.target);
      if (!button) return;

      var form = button.closest(".product-form");
      if (!form) return;

      var variantNode =
        form.querySelector(".options.active .iddavariante") ||
        form.querySelector(".options .iddavariante");
      if (!variantNode) return;

      var variantId = parseInt(variantNode.getAttribute("val"), 10);
      var quantity = parseInt(variantNode.getAttribute("qtd"), 10) || 1;
      if (!variantId) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (button.getAttribute("data-mt-adding") === "1") return;
      button.setAttribute("data-mt-adding", "1");
      button.setAttribute("aria-busy", "true");

      var items = [{ id: variantId, quantity: quantity }];
      form
        .querySelectorAll(".buy-together-list input:checked")
        .forEach(function (input) {
          var id = parseInt(input.getAttribute("data-id"), 10);
          if (id) items.push({ id: id, quantity: 1 });
        });

      var cartAddUrl =
        window.routes && window.routes.cartAddUrl
          ? window.routes.cartAddUrl
          : "/cart/add";
      fetch(cartAddUrl + ".js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error("cart_add_failed");
          window.location.assign("/cart");
        })
        .catch(function () {
          button.removeAttribute("data-mt-adding");
          button.removeAttribute("aria-busy");
        });
    },
    true,
  );
})();
